import { render, staticRenderFns } from "./NewFeasibility.vue?vue&type=template&id=65ec5a00&scoped=true"
import script from "./NewFeasibility.vue?vue&type=script&lang=js"
export * from "./NewFeasibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec5a00",
  null
  
)

export default component.exports